<template>
  <!-- <VuePerfectScrollbar
    class="history-area"
    :settings="settings"
  > -->
  <div
    class="history-area style-custome"
    style="width: 100%; overflow: auto; background: none"
    id="style-1"
  >
    <div class="org-tree-container" id="luongXuLy">
      <div class="org-tree" :class="{ horizontal, collapsable }">
        <org-tree-node
          :data="data"
          :props="props"
          :horizontal="horizontal"
          :label-width="labelWidth"
          :collapsable="collapsable"
          :render-content="renderContent"
          :label-class-name="labelClassName"
          @on-expand="$emit('onExpand', $event)"
          @on-node-click="
            (e, data) => {
              $emit('onNodeClick', e, data);
            }
          "
        ></org-tree-node>
      </div>
    </div>
  </div>
  <!-- </VuePerfectScrollbar> -->
</template>
<script>
import render from "./node";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  name: "Vue2OrgTree",
  components: {
    VuePerfectScrollbar,
    OrgTreeNode: {
      render,
      functional: true,
    },
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    props: {
      type: Object,
      default: () => ({
        label: "label",
        expand: "expand",
        children: "children",
        moreInfo: "moreInfo",
      }),
    },
    horizontal: Boolean,
    collapsable: Boolean,
    renderContent: Function,
    labelWidth: [String, Number],
    labelClassName: [Function, String],
  },
  data() {
    return {
      settings: {
        maxScrollbarLength: 750,
      },
    };
  },
  mounted() {
    const slider = document.querySelector(".style-custome");
    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener("mousedown", (e) => {
      isDown = true;
      slider.classList.add("active");
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });
    slider.addEventListener("mouseleave", () => {
      isDown = false;
      slider.classList.remove("active");
    });
    slider.addEventListener("mouseup", () => {
      isDown = false;
      slider.classList.remove("active");
    });
    slider.addEventListener("mousemove", (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 3; //scroll-fast
      slider.scrollLeft = scrollLeft - walk;
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/views/doc-out/components/vue2-tree/components/org-tree/org-tree.vue